<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addEditMarche.produits.filtre.categorie')">
            <qd-taginput
              v-if="filteredTags"
              v-model="critereRecherche.categorie"
              :data="filteredTags"
              @typing="getFilteredTags"
              @input="getTypeTags"
              field="libellei18n"
              type="is-primary"
              icon="magnify"
              autocomplete
              open-on-focus>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addEditMarche.produits.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('addEditMarche.produits.filtre.avecLiaisons')">
            <b-select v-model="critereRecherche.avecLiaisons">
              <option :value="null"></option>
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERE_RECHERCHE_PRODUITS } from '@/store/modules/achat/marche-mutation-type';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import { genererCritereRechercheProduits } from '@/services/achat/marche/genererCritereRecherche';

const Marche = createNamespacedHelpers('marche');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      critereRecherche: null,
    };
  },
  computed: {
    ...Marche.mapGetters({
      critereRechercheFromStore: 'criteresRechercheProduits',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    filteredTags() {
      return traductionLibelleEtat(this.$i18n, this.categorieProduit);
    },
  },
  methods: {
    ...Marche.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE_PRODUITS,
    }),
    getTypeTags() {
      this.filteredTags = this.categorieProduit.filter((option) => {
        return !this.critereRecherche.categorie.map(c => c.code).includes(option.code);
      });
    },
    getFilteredTags(text) {
      this.getTypeTags();
      this.filteredTags = this.filteredTags.filter((option) => {
        return this.$i18n.t(option.libelle)
          .toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheProduits());
      this.getTypeTags();
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('close');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
